import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";
import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const MemberEducationChart = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [status, setStatus] = useState({
    single: 0,
    married: 0,
    committed: 0,
  });
  const [refreshing, setRefreshing] = useState(false);

  const getFamilyStatus = async () => {
    try {
      const result = await fetchApi.get("members-graph/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        const apiData = result.data;

        const statusCounts = apiData.reduce((counts, item) => {
          counts[item.marital_status] = (counts[item.marital_status] || 0) + 1;
          return counts;
        }, {});

        setStatus({
          single: statusCounts.single || 0,
          married: statusCounts.married || 0,
          committed: statusCounts.committed || 0,
        });
      }
    } catch (error) {
      console.error("Error fetching marital status data:", error);
    }
  };

  useEffect(() => {
    getFamilyStatus();
  }, []);

  async function handleRefresh(params) {
    setRefreshing(true);
    await getFamilyStatus();
    setRefreshing(false);
  }

  const data = {
    labels: ["Single", "Married", "Committed"],
    datasets: [
      {
        data: [status.single, status.married, status.committed],
        backgroundColor: ["#7086fd", "#6fd195", "#ffae4c"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 6,
          usePointStyle: true,
          padding: 15,
          color: "#000",
          font: { size: 14, family: "'Plus Jakarta Sans', sans-serif", weight: "500" },
        },
      },
    },
  };

  return (
    <div className=" w-full bg-white sm:p-5 p-2.5 rounded-xl shadow">
      <div className="dashboardCard">
        <div className="flex items-center justify-between gap-2">
          <p style={{ color: "black", fontSize: "20px" }}>Marital Status</p>
          <span
            onClick={handleRefresh}
            disabled={refreshing}
            className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
          >
            <FiRefreshCcw
              className={`text-gray-600 text-lg ${
                refreshing ? "animate-spin" : ""
              }`}
            />
          </span>
        </div>

        <Link to="/memberdetailpage">
          <div className="w-full h-[300px] flex flex-col items-center justify-center">
            <div className="w-full h-full">
              <Pie data={data} options={options} />
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default MemberEducationChart;
